import HttpClient from '../../../services/http-client';
import { IUploadedImageResponse } from '../../../../model/apm/image/response/uploaded-image-response';

const defaultPath = 'Image';

// O Content-Type multipart (com boundary) é definido pelo axios a partir do FormData
const upload = async (file: File, onProgress?: (percent: number) => void): Promise<IUploadedImageResponse> => {
    const formData = new FormData();
    formData.append('File', file);

    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: formData,
        onUploadProgress: (event) => {
            if (onProgress && event.total) {
                onProgress(Math.round((event.loaded * 100) / event.total));
            }
        }
    }).then((response) => response.data);
};

const ImageAppService = { upload };
export default ImageAppService;
